import type { Styles } from "react-select/src/styles";

import type { DropdownOption } from "./DropdownOption";

const commonDropdownStyle: Styles<DropdownOption, false> = {
  container: (provided: React.CSSProperties) => ({
    ...provided,
    height: "100%",
    flex: 1,
  }),
  control: (provided: React.CSSProperties, { menuIsOpen }: { menuIsOpen: boolean }) => ({
    ...provided,
    backgroundColor: "#FFF",
    border: `1px solid ${menuIsOpen ? "#1A7FDA" : "#D8D8D8"}`,
    boxShadow: "none",
    borderRadius: 5,
    minWidth: 150,
  }),
  menuList: (provided: React.CSSProperties) => ({
    ...provided,
    padding: "8px",
    "&::-webkit-scrollbar": {
      width: "8px",
      backgroundColor: "#F5F5F5",
    },
    "&::-webkit-scrollbar-track": {
      borderRadius: "4px",
      backgroundColor: "#FAFAFF",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#BBBBBB",
      borderRadius: "4px",
    },
  }),
  menu: (provided: React.CSSProperties) => ({
    ...provided,
    marginTop: 0,
    border: "none",
    borderRadius: 5,
    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
    minWidth: 150,
  }),
  menuPortal: (provided: React.CSSProperties) => ({ ...provided, zIndex: 9999 }),
  option: (provided: React.CSSProperties, { isDisabled }: { isDisabled: boolean }) => ({
    ...provided,
    display: "flex",
    alignItems: "start",
    padding: "4px",
    color: "#3F4B6C",
    cursor: isDisabled ? "not-allowed" : "default",
    backgroundColor: "#FFF",
    "&:hover": {
      backgroundColor: "#1A7FDA",
      color: "#FFF",

      "span.checkbox-icon": {
        boxShadow: "inset 0 0 0 1px #FFFFFF",
      },
    },
  }),
  singleValue: (provided: React.CSSProperties) => ({
    ...provided,
    border: "none",
  }),
  multiValue: (provided: React.CSSProperties) => ({
    ...provided,
    border: "none",
  }),
  dropdownIndicator: (provided: React.CSSProperties) => ({
    ...provided,
    color: "#3F4B6C !important",
  }),
  valueContainer: (provided: React.CSSProperties) => ({
    ...provided,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "initial",
    width: "0px",
  }),
  placeholder: (provided: React.CSSProperties) => ({
    ...provided,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    color: "inherit",
    width: "100%",
  }),
};

export const checkboxDropdownStyle: Styles<DropdownOption, false> = {
  ...commonDropdownStyle,
};

export const buttonDropdownStyle: Styles<DropdownOption, boolean> = {
  ...commonDropdownStyle,
  valueContainer: (provided: React.CSSProperties) => ({
    ...provided,
    height: 0,
    padding: 0,
  }),
  menu: (provided: React.CSSProperties) => ({
    ...provided,
    marginTop: 0,
    border: "none",
    borderRadius: 5,
    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
    minWidth: 150,
    right: 16,
  }),
};
